import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewContactusLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-contactus-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-contactus-content-component')
  );

  return (
    <div className="contact-us-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewContactusLandingPage;
